module.exports = __webpack_public_path__ + "img/mapg.010bb27d.png";